/**
 * German copy used when BOOKING_RMD_3H_TIME_WINDOW is on.
 * Missing/false flag keeps the 2h strings in de.ts.
 */
const deThreeHourOverrides = {
  notificationBox: {
    description: {
      fixedDate:
        "Ihr Auftrag wird zur Zeit zur Auslieferung vorbereitet. Wir melden uns am Vortag der Lieferung mit einem 3h-Zeitfenster bei Ihnen."
    }
  },
  appointment: {
    summary: {
      icsFileEmailBody:
        "Hallo {name},<br>Ihr Termin für Ihren {clientName}-Auftrag {orderNumber} steht fest.<br>" +
        "Das voraussichtliche Lieferzeitfenster wird am Vortag der Lieferung um ca. 15-16 Uhr auf 3 Stunden eingegrenzt.<br>" +
        "Diese und weitere Informationen rund um Ihre Lieferung können Sie auf Rhenusmydelivery.com/de einsehen.<br><br>" +
        '<a href="https://www.rhenusmydelivery.com/de">Jetzt Sendung verfolgen!</a><br><br>' +
        "Ihr Rhenus Home Delivery Team"
    }
  }
};

export default deThreeHourOverrides;
